"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlayWidgetManager = void 0;
var WidgetManager_1 = require("./WidgetManager");
Object.defineProperty(exports, "OverlayWidgetManager", { enumerable: true, get: function () { return WidgetManager_1.OverlayWidgetManager; } });
//# sourceMappingURL=index.js.map